import React from "react";
import MessageIcon from "./MessageIcon";
import OrderStatus from "./OrderStatus";
import { Icon } from "semantic-ui-react";

const InfoBarMessages = (props) => {
  const {
    waitingForDeliveryRequest,
    waitingForNewIPackBox,
    nextAction,
    operatorInstruction,
    isPartialDelivery,
    wasCancelled,
    allVerified,
    rxCheckSubsidy = false,
    loopTeamleader = false
  } = props;

  if (waitingForDeliveryRequest && !waitingForNewIPackBox && allVerified) {
    return (
      <div className="pushDaButtonsContainer">
        <Icon className="flipped" name="hand point down outline" />
        <span className="pushDaButtons">TRYCK PÅ KNAPPARNA</span>
        <Icon className="righthand" name="hand point down outline" />
      </div>
    );
  } else {
    return (
      <React.Fragment>
        <div className="flexRow fullWidth">
          <MessageIcon nextAction={nextAction}></MessageIcon>
          <span style={{ flexGrow: 1 }}>{operatorInstruction}</span>
          {props.children}
        </div>
        {loopTeamleader && (
          <div className="flexRow fullWidth spaceEnd">
            <div>Ansvarig</div>
          </div>
        )}
        <OrderStatus
          isPartialDelivery={isPartialDelivery}
          wasCancelled={wasCancelled}
          rxCheckSubsidy={rxCheckSubsidy}
        ></OrderStatus>
      </React.Fragment>
    );
  }
};

export default InfoBarMessages;
